import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { LayoutDashboard, Megaphone, Users, MessagesSquare, Settings2, LogOut, Menu, X, Building2 } from "lucide-react";
import { KWordmark } from "@/components/KLogo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/gestao", icon: LayoutDashboard, label: "Visão geral", end: true },
  { to: "/gestao/comunicacao", icon: Megaphone, label: "Comunicação" },
  { to: "/gestao/moradores", icon: Users, label: "Moradores" },
  { to: "/gestao/comunidade", icon: MessagesSquare, label: "Comunidade" },
  { to: "/gestao/servicos", icon: Settings2, label: "Serviços" },
  { to: "/gestao/perfil", icon: Building2, label: "Perfil" },
];

export default function ManagerLayout() {
  const { condo, user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const Sidebar = () => (
    <div className="flex flex-col h-full">
      <div className="p-5"><KWordmark size={30} /></div>
      <div className="px-5 pb-4">
        <div className="glass rounded-2xl p-3">
          <p className="text-xs text-muted-foreground">Painel do síndico</p>
          <p className="text-sm font-semibold font-display truncate">{condo?.name}</p>
        </div>
      </div>
      <nav className="flex-1 px-3 space-y-1">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`mgr-nav-${n.label.split(" ")[0].toLowerCase()}`}
            className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-2xl text-sm font-medium transition-colors ${isActive ? "brand-gradient text-white glow-primary" : "text-muted-foreground hover:bg-white/5 hover:text-foreground"}`}>
            <n.icon className="w-5 h-5" /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3">
        <button onClick={logout} data-testid="mgr-logout" className="flex items-center gap-3 px-4 py-3 rounded-2xl text-sm font-medium text-red-400 hover:bg-red-500/10 transition-colors w-full">
          <LogOut className="w-5 h-5" /> Sair
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-[100dvh] bg-background flex">
      <aside className="hidden lg:block w-72 border-r border-white/5 shrink-0 sticky top-0 h-[100dvh]">
        <Sidebar />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} />
          <div className="relative w-72 glass-strong border-r border-white/10 h-full float-in">
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 p-1"><X className="w-5 h-5" /></button>
            <Sidebar />
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0">
        <header className="lg:hidden sticky top-0 z-30 glass-strong border-b border-white/5 h-14 flex items-center justify-between px-4">
          <button onClick={() => setOpen(true)} data-testid="mgr-menu-btn" className="p-2 rounded-full hover:bg-white/10"><Menu className="w-5 h-5" /></button>
          <KWordmark size={26} />
          <div className="w-9" />
        </header>
        <main className="max-w-6xl mx-auto p-5 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
